var chunkMapping = {
	"3": [
		1375
	],
	"38": [
		6565
	],
	"72": [
		7072
	],
	"113": [
		6113
	],
	"166": [
		7573
	],
	"234": [
		947
	],
	"244": [
		681
	],
	"365": [
		4355
	],
	"421": [
		5735
	],
	"464": [
		3637
	],
	"529": [
		2843
	],
	"659": [
		865
	],
	"703": [
		8773
	],
	"741": [
		5895
	],
	"891": [
		5457
	],
	"990": [
		2117
	],
	"993": [
		6045
	]
};
var idToExternalAndNameMapping = {
	"681": [
		"default",
		"./HeaderApp",
		5464
	],
	"865": [
		"default",
		"./EcommerceApp",
		6004
	],
	"947": [
		"default",
		"./AuthApp",
		3830
	],
	"1375": [
		"default",
		"./BookingBuilderApp",
		4346
	],
	"2117": [
		"default",
		"./EmailBuilderApp",
		4716
	],
	"2843": [
		"default",
		"./CustomerAuthenticationApp",
		3334
	],
	"3637": [
		"default",
		"./DynamicFormsAdminApp",
		8108
	],
	"4355": [
		"default",
		"./DynamicFormsApp",
		7430
	],
	"5457": [
		"default",
		"./SidebarApp",
		7908
	],
	"5735": [
		"default",
		"./ServicesApp",
		5258
	],
	"5895": [
		"default",
		"./WebsiteBuilderApp",
		466
	],
	"6045": [
		"default",
		"./POSApp",
		2496
	],
	"6113": [
		"default",
		"./MarketingApp",
		4780
	],
	"6565": [
		"default",
		"./OffersApp",
		7900
	],
	"7072": [
		"default",
		"./IdleSessionApp",
		6972
	],
	"7573": [
		"default",
		"./POSBackOfficeApp",
		8764
	],
	"8773": [
		"default",
		"./ProductManagementApp",
		6272
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}